
export const addToFavorite = (idsf, container = null) => {
	if(window.AuthorizationSF) {
		return window.axios.post(window.appUrl + '/api/travel-preferences',
		{
			structureId: idsf
		},
		{
			headers: {
				'Authorization-SF': window.AuthorizationSF
			},
			withCredentials: true
		})
		.then(function(response) {
			if (response.status === 200) {
				if(container) {
					if(response.data.is_favorite) {
						container.find("svg path").attr("fill", "#18243D");
					} else {
						container.find("svg path").attr("fill", "");
					}
				}
				return response.data
			} else {
				console.log("Errore: risposta inaspettata", response);
			}
		})
		.catch(function(error) {
			console.log("Errore nella richiesta:", error);
		});
	} else {
		$('#area-riservata').modal('show');
		return null;
	}
}

export const saveSearchApi = () => {
	if(window.AuthorizationSF) {
		return window.axios.post(window.appUrl + '/save-search',
		{
			url: window.location.href
		},
		{
			headers: {
				'Authorization-SF': window.AuthorizationSF
			},
			withCredentials: true
		})
		.then(function(response) {
			if (response.status === 200) {
				console.log( response);
				return true;
			} else {
				console.log("Errore: risposta inaspettata", response);
			}
		})
		.catch(function(error) {
			console.log("Errore nella richiesta:", error);
		});
	} else {
		const links = document.getElementsByClassName("btn-loginsl");
		const url = new URL(links[0].href);
		url.searchParams.set("state", window.location.href+'&action=saveSearch');

		links[0].href = url.toString();

		const linkssignup = document.querySelector(".btn-signupsl");

		if (linkssignup) {
			const urlreg = new URL(linkssignup.href);
			urlreg.searchParams.set(
				"lastViewedUrl",
				window.location.href + '&action=saveSearch'
			);
			linkssignup.href = urlreg.toString();
		}



		$('#area-riservata').modal('show');
		return null;
	}
}